import React, { useState } from "react";
import configVars from "../../config";
import { useCookies } from "react-cookie";
import validator from "validator";
import { useParams } from 'react-router-dom';
import Alert from "../Alert";

const ChangeOwner = (props) => {

    const [newEmail, setNewEmail] = useState('');
    const [isManager, setIsManager] = useState(false);
    const [deleteOldManager, setDeleteOldManager] = useState(false);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [loading, setLoading] = useState(false);
    const { organization_id } = useParams();
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleSubmit = async (event) => {

        event.preventDefault();

        if ( !newEmail.toString().trim().length ) return;

        if (!validator.isEmail(newEmail)) return;

        setLoading(true);
        setIsError( false );
        setErrorMsg('');

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'new_email', newEmail );
            userRequestData.append( 'organization_id', organization_id );
            userRequestData.append( 'is_manager', isManager );
            userRequestData.append( 'delete_old', deleteOldManager );


        const response = await fetch(
            `${configVars.apiUrl}sustainchange/v1/changeorgowner/`,
            {
                method: "POST",
                headers: {
                Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
            }
        );

        const memberResponse = await response.json();

        if ( memberResponse ) {

            if ( memberResponse.success === true ) {

                localStorage.removeItem( `sy_org_${organization_id}_data` );
                window.location.href = `/organizations/${organization_id}/admin/`;

            } else {
                setIsError( true );
                setErrorMsg( memberResponse.message );
            }
        }

        setLoading(false);

    }

    return (
        <div className="summary-wrap pb-5 pb-lg-6" style={{ maxWidth: "1200px" }}>
            <h3 className="mb-4">Byt Organisationsägare</h3>

            {isError &&
                <div className="mt-3" style={{ maxWidth: "800px" }}>
                    <Alert type="danger" msg={errorMsg}  />
                </div>
            }

            <form onSubmit={ (event) => handleSubmit(event) }>
                
                <div className="row mb-3">
                    <div className="col-12 col-lg-8">
                        <input type="email" className="form-control bg-white rounded-pill" placeholder="Ny ägare e-post...." value={newEmail} onChange={(e) => setNewEmail(e.target.value)} />
                    </div>
                    <div className="col-12 col-lg-4">
                        <button type="submit" className="btn btn-secondary rounded-pill">
                            <span className="me-2">Byt</span>
                            {!loading &&
                                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                            }
                            {loading &&
                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }
                        </button>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <div className="form-check form-switch">
                            <input className="form-check-input" type="checkbox" role="switch" id="remove_type" value={deleteOldManager} onChange={() => setDeleteOldManager(!deleteOldManager)} />
                            <label className="form-check-label" htmlFor="remove_type">Tabort den gamla ägaren {`( ${props?.owner?.name} )`}</label>
                        </div>
                    </div>
                </div>

                {! deleteOldManager &&
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="member_type" value={isManager} onChange={() => setIsManager(!isManager)} />
                                <label className="form-check-label" htmlFor="member_type">Gör den gamla ägaren till en chef</label>
                            </div>
                        </div>
                    </div>
                }

            </form>
        </div>
    );

}

export default ChangeOwner;